<template>
    <div v-if="isVisible" class="modal-overlay">
        <SickDaysEditModal v-if="isEditDialogVisible" :sickDayId="editSickDayId" :contractId="contractId" :allSickDays="sickDays" :show="isEditDialogVisible" @update="update" @close="closeEditDialog" />
        <div class="modal">
            <div class="modal-header">
                <h3>{{ title }}</h3>
                <button @click="closeModal" class="btn-close">&times;</button>
            </div>
            <div class="modal-body">
                <div class="container">
                    <div class="filter-container">
                        <div class="filter">
                            <label>Von</label>
                            <input type="date" v-model="filter.dateStart">
                        </div>
                        <div class="filter">
                            <label>Bis</label>
                            <input type="date" v-model="filter.dateEnd">
                        </div>
                        <div class="filter">
                            <label>Arbeitsunfähigkeitsbescheinigung?</label>
                            <select v-model="filter.attested">
                                <option :value="null">Alle</option>
                                <option :value="true">Ja</option>
                                <option :value="false">Nein</option>
                            </select>
                        </div>
                    </div>
                    <div class="add-button">
                        <button class="btn-update btn-right" @click="openAddDialog">Eintrag hinzufügen</button>
                    </div>
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Erster Tag</th>
                                <th>Letzter Tag</th>
                                <th>AU?</th>
                                <th>AU eingereicht am</th>
                                <th>Eingetragen durch</th>
                                <th v-if="getUserData().isAdmin">Aktionen</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(note, index) in filteredSickDays" :key="index">
                                <td>{{ note.startDate }}</td>
                                <td>{{ note.endDate }}</td>
                                <td>{{ note.attested ? "Ja" : "Nein" }}</td>
                                <td>{{ note.attestSubmittedOn }}</td>
                                <td>{{ note.usernameRegisteredBy }}</td>
                                <td v-if="getUserData().isAdmin">
                                    <div class="button-footer">
                                        <button class="btn-update btn-right" @click="openEditDialog(note.id)">Bearbeiten</button>
                                        <button class="btn-update btn-right" @click="deleteSickDay(note)">Löschen</button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import apiService from "@/service";
import SickDaysEditModal from "./SickDaysEditModal.vue";

export default {
    name: "SickDaysModal",
    components: {
        SickDaysEditModal
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        employeeName: {
            type: String,
            default: null
        },
        contractId: {
            type: Number,
            default: null
        }
    },
    data(){
        return {
            sickDays: [],
            isEditDialogVisible: false,
            editSickDayId: null,
            filter: {
                dateStart: '',
                dateEnd: '',
                attested: null
            }
        }
    },
    computed: {
        isVisible(){
            return this.show;
        },
        title(){
            if(this.employeeName)
                return 'Krankheitstage - ' + this.employeeName;
            else
                return 'Krankheitstage';
        },
        filteredSickDays(){
            return this.sickDays.filter(sickDay => {
                let filterStart = this.filter.dateStart ? new Date(new Date(this.filter.dateStart).toDateString()) : null;
                let filterEnd = this.filter.dateEnd ? new Date(new Date(this.filter.dateEnd).toDateString()) : null;
                
                let startDate = new Date(new Date(sickDay.startDateOrig).toDateString());
                let endDate = sickDay.endDateOrig ? new Date(new Date(sickDay.endDateOrig).toDateString()) : null;

                let passed = ((filterEnd ? filterEnd > startDate : true) && (endDate ? endDate > filterStart : true)) || (!filterEnd && !endDate);

                passed &= this.filter.attested != null ? sickDay.attested == this.filter.attested : true;

                return passed;
            });
        }
    },
    methods: {
        getUserData() {
            var jsonString = localStorage.getItem('userData');
            return jsonString ? JSON.parse(jsonString) : null;
        },
        closeModal(){
            this.$emit('close');
        },
        getAllSickDays(){
            apiService.get(`/SickDays/GetAllByContractId?contractId=${this.contractId}`).then(response => {
                    this.sickDays = response.data.map(item => ({
                        id: item.id,
                        contractId: item.contractId,
                        startDate: new Intl.DateTimeFormat("de-DE", {month:'2-digit',day:'2-digit', year:'numeric'}).format(new Date(item.startDate)),
                        startDateOrig: item.startDate,
                        endDate: item.endDate ? new Intl.DateTimeFormat("de-DE", {month:'2-digit',day:'2-digit', year:'numeric'}).format(new Date(item.endDate)) : "-",
                        endDateOrig: item.endDate,
                        attested: item.attested,
                        attestSubmittedOn: item.attestSubmittedOn ? new Intl.DateTimeFormat("de-DE", {month:'2-digit',day:'2-digit', year:'numeric'}).format(new Date(item.attestSubmittedOn)) : "-",
                        usernameRegisteredBy: item.usernameRegisteredBy
                    }));
                })
            .catch(error => {
                console.log('Get SickDays error: ', error);
            });
        },
        update(){
            this.getAllSickDays();
            this.$emit("update");
        },
        openAddDialog(){
            this.editSickDayId = null;
            this.isEditDialogVisible = true;
        },
        openEditDialog(id){
            this.editSickDayId = id;
            this.isEditDialogVisible = true;
        },
        closeEditDialog(){
            this.editSickDayId = null;
            this.isEditDialogVisible = false;
        },
        deleteSickDay(entry){
            var result = confirm(`Soll der Eintrag zur Krankheitsdauer (${entry.startDate} - ${entry.endDate ? entry.endDate : "offen"}) wirklich gelöscht werden?`);
            
            if(result){
                apiService.get(`/SickDays/Delete?id=${entry.id}`).then(() => {
                    this.getAllSickDays();
                }).catch(error => {
                    console.log(`Error deleting sick day: ${error}`);
                })
            }
        }
    },
    mounted(){
        this.getAllSickDays();
    }
}
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    gap: 1rem
}

.btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #4d4d4d;
}

.btn-close:hover {
  color: #c0c0c0;
}

.button-footer button {
    margin-left: 5px;
}

.button-footer button:hover {
    cursor: pointer;
    background-color: #c0c0c0;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal {
  background: #fff;
  padding: 2rem;
  border-radius: 5px;
  width: 80%;
  min-width: 700px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-body {
  margin: 15px 0;
}

.modal-body table {
    display: flex;
    flex-flow: column;
    width: 100%;
    height: 500px;
}

.modal-body thead {
    padding-right: 13px;
}

.modal-body tbody {
    display: block;
    overflow-y: auto;
}

.modal-body tr {
    width: 100%;
    display: table;
    table-layout: fixed;
}

.add-button {
    margin-left: auto;
}
</style>